// Б.2.b: Диспетчер action-карт Синтетикса.
//
// Action-карты Синтетика идут из колоды → в руку → в Ф2 ставятся в action-слот →
// в Ф3 резолвятся (после Действий Деуса, после вскрытия юнитов).
//
// Правила (для всех 4 Действий Синтетика):
//   - Розыгрыш Действия НЕ тикает счётчик прогрессии (1→2→3→4→5).
//   - Действие — основная карта в смысле правил Синтетика: можно сыграть Мод
//     дополнительно к Действию (логика в match.canAddPlacement / placementBudget).
//   - Если Действие даёт юниту Мод (Прошивка, Пропаганда), это считается
//     «получением Мода» (Бишор реагирует), но НЕ «розыгрышем Мода с руки»
//     (Хирург НЕ реагирует, прогрессия НЕ тикает) — это обеспечивается тем,
//     что attachMod вызывается БЕЗ source.isPlayed.

import { CARD_ID as ID_STIM,    getTargets as getStimTargets,    resolveStimulator }   from './kustarnyy-stimulyator.js';
import { CARD_ID as ID_UDAR,    getTargets as getUdarTargets,    resolveUdar }         from './udar-elektro-knutom.js';
import { CARD_ID as ID_PROSH,   resolveProshivka }                                     from './massovaya-proshivka.js';
import { CARD_ID as ID_PROPAGANDA, resolvePropaganda }                                  from './propaganda-v-bare.js';
// Этап 25: Действия Синтетика на v6 ID (через registerC1Order).
import { fireC1Order, hasC1Order } from '../global/c1/order-registry.js';

// v6 Действия требующие target.
const TARGETED_C1_SYN = new Set([
  'syn_act_elektroknut', 'syn_act_stim', 'syn_act_implantatsia_v_podvale',
  'syn_act_boevoy_stend', 'syn_act_pereproshivka', 'syn_act_rekvizitsiya',
  'syn_act_shedevr_inzhenerii'
]);

const TARGETED = new Set([ID_STIM, ID_UDAR]);

export function actionNeedsTarget(cardId) {
  if (TARGETED_C1_SYN.has(cardId)) return true;
  return TARGETED.has(cardId);
}

export function getActionTargets(state, playerIdx, cardId) {
  // Этап 25: v6 действия — target из своих/чужих юнитов.
  if (cardId.startsWith('syn_act_')) {
    const p = state.players?.[playerIdx];
    const enemy = state.players?.[1 - playerIdx];
    const allies = [];
    const enemies = [];
    if (p?.field) for (const row of p.field) for (const u of row || []) if (u) allies.push(u);
    if (enemy?.field) for (const row of enemy.field) for (const u of row || []) if (u) enemies.push(u);
    switch (cardId) {
      case 'syn_act_elektroknut':
        return [...allies, ...enemies];
      case 'syn_act_stim':
      case 'syn_act_implantatsia_v_podvale':
      case 'syn_act_boevoy_stend':
      case 'syn_act_pereproshivka':
      case 'syn_act_rekvizitsiya':
      case 'syn_act_shedevr_inzhenerii':
        return allies;
      default:
        return [];
    }
  }
  switch (cardId) {
    case ID_STIM: return getStimTargets(state, playerIdx);
    case ID_UDAR: return getUdarTargets(state, playerIdx);
    case ID_PROSH:
    case ID_PROPAGANDA:
      return [];
    default:
      return [];
  }
}

export function resolveAction(state, playerIdx, cardId, targetCard = null, opts = {}) {
  // Этап 25: v6 действия через registerC1Order.
  if (cardId.startsWith('syn_act_') && hasC1Order(cardId)) {
    const fakeSource = { id: cardId, ownerId: playerIdx, name_ru: cardId };
    const r = fireC1Order(state, playerIdx, fakeSource, { ...opts, target: targetCard });
    return r || { ok: false, reason: 'c1_order_failed' };
  }
  switch (cardId) {
    case ID_STIM:       return resolveStimulator(state, playerIdx, targetCard);
    case ID_UDAR:       return resolveUdar(state, playerIdx, targetCard);
    case ID_PROSH:      return resolveProshivka(state, playerIdx);
    case ID_PROPAGANDA: return resolvePropaganda(state, playerIdx);
    default:            return { ok: false, reason: 'unknown_action' };
  }
}

// Реэкспорт ID для индекса.
export {
  ID_STIM    as STIMULATOR_ID,
  ID_UDAR    as UDAR_ID,
  ID_PROSH   as PROSHIVKA_ID,
  ID_PROPAGANDA as PROPAGANDA_ID
};
